import * as Font from "expo-font";
import { FontSource } from "expo-font";
export function cacheFonts(fonts: (string | Record<string, FontSource>)[]) {
  return fonts.map((font) => Font.loadAsync(font));
}
